import React from 'react';
import { Gamepad2, Star, Zap, Heart } from 'lucide-react';

const ArcadeFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-deep-purple border-t-4 border-dark-border overflow-hidden">
      {/* Decorative top border glow */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-neon-pink to-transparent opacity-50" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand & Description */}
          <div className="text-center md:text-left">
            <div className="mb-4">
              <span className="font-terminal text-2xl text-foreground">Singularity</span>
              <span className="font-terminal text-2xl text-trophy-gold"> Labs</span>
            </div>
            <p className="font-terminal text-lg text-lavender">
              Earn cash by helping train AI & robots with real-world video data.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="font-pixel text-xs text-neon-pink mb-4">QUICK LINKS</h4>
            <nav className="space-y-2">
              {[
                { href: '#leaderboard', label: 'Leaderboard' },
                { href: '#side-quests', label: 'Side Quests' },
                { href: '#how-it-works', label: 'How It Works' },
                { href: '#submit', label: 'Submit Data' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block font-terminal text-xl text-lavender hover:text-neon-pink transition-colors"
                >
                  <Gamepad2 className="inline-block w-4 h-4 mr-2" />
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Status */}
          <div className="text-center md:text-right">
            <h4 className="font-pixel text-xs text-neon-pink mb-4">PLATFORM STATUS</h4>
            <div className="space-y-3">
              <div className="flex items-center justify-center md:justify-end gap-2">
                <span className="status-dot" />
                <span className="font-terminal text-xl text-success-green">SEASON LIVE</span>
              </div>
              <div className="flex items-center justify-center md:justify-end gap-2">
                <Star className="w-4 h-4 text-trophy-gold" />
                <span className="font-terminal text-xl text-lavender">QUESTS OPEN</span>
              </div>
              <div className="flex items-center justify-center md:justify-end gap-2">
                <Zap className="w-4 h-4 text-warning-orange" />
                <span className="font-terminal text-xl text-lavender">CASH REWARDS</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t-2 border-panel-purple pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-terminal text-lg text-muted">
              © {currentYear} Singularity Labs. All rights reserved.
            </p>
            <p className="font-terminal text-lg text-muted flex items-center gap-1">
              Made with <Heart className="w-4 h-4 text-neon-pink animate-pulse" /> for AI & Robotics
            </p>
          </div>
        </div>

        {/* Decorative pixels */}
        <div className="absolute bottom-4 left-4 flex gap-1 opacity-30">
          <div className="w-2 h-2 bg-neon-pink" />
          <div className="w-2 h-2 bg-trophy-gold" />
          <div className="w-2 h-2 bg-success-green" />
        </div>
        <div className="absolute bottom-4 right-4 flex gap-1 opacity-30">
          <div className="w-2 h-2 bg-success-green" />
          <div className="w-2 h-2 bg-trophy-gold" />
          <div className="w-2 h-2 bg-neon-pink" />
        </div>
      </div>
    </footer>
  );
};

export default ArcadeFooter;
